module.exports = __webpack_public_path__ + "img/person-settings.4b01feaa.svg";